import { render, staticRenderFns } from "./TextFade.vue?vue&type=template&id=0ada86cc&scoped=true&"
import script from "./TextFade.vue?vue&type=script&lang=js&"
export * from "./TextFade.vue?vue&type=script&lang=js&"
import style0 from "./TextFade.vue?vue&type=style&index=0&id=0ada86cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada86cc",
  null
  
)

export default component.exports